import {getContext, setContext} from "svelte"
import {writable} from "svelte/store"

/**
 * @typedef {{
 *   type: "wide" | "compact",
 *   funcHorizontalScroll: (delta: number) => void,
 * }} TableContextValueType
 */

/**
 * @type {TableContextValueType}
 */
const defaultTableContextValue = {
  type: "wide",
  funcHorizontalScroll: () => {},
}

const createTableContextValueStore = (initialValues) => {
  return writable(initialValues ?? defaultTableContextValue)
}

const tableContextSymbol = Symbol("table")

export function getTableContext() {
  return getContext(tableContextSymbol)
}

/**
 *
 * @param {TableContextValueType} [tableContextValue]
 */
export function setTableContext(tableContextValue) {
  const store = createTableContextValueStore(tableContextValue)
  setContext(tableContextSymbol, store)
  return store
}
